export default __webpack_public_path__ + "static/media/greaterThanOrEqualTo.22cc6eff.svg";